import { render, staticRenderFns } from "./productSpecManage.vue?vue&type=template&id=21b8efda&scoped=true"
import script from "./productSpecManage.vue?vue&type=script&lang=js"
export * from "./productSpecManage.vue?vue&type=script&lang=js"
import style0 from "./productSpecManage.vue?vue&type=style&index=0&id=21b8efda&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21b8efda",
  null
  
)

export default component.exports